/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class CleanUpVisualizationAPI
 * @hideconstructor
 */
define([], () => {
	class CleanUpVisualizationAPI {

	}

	return CleanUpVisualizationAPI;
});
